var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _path0, _rect, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#F9EFE2;}\n\t.st3{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.31,182.14c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C30.02,147.84,64.62,182.14,107.31,182.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.58,137.63c-11.03,0-20.01-8.97-20.01-20.01c0-11.03,8.98-20.01,20.01-20.01c11.04,0,20.01,8.98,20.01,20.01 C91.59,128.65,82.61,137.63,71.58,137.63z M71.58,101.52c-8.88,0-16.1,7.22-16.1,16.1c0,8.88,7.22,16.1,16.1,16.1 c8.88,0,16.1-7.22,16.1-16.1C87.68,108.74,80.45,101.52,71.58,101.52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.05,137.63c-11.03,0-20.01-8.97-20.01-20.01c0-11.03,8.98-20.01,20.01-20.01 c11.04,0,20.01,8.98,20.01,20.01C163.06,128.65,154.09,137.63,143.05,137.63z M143.05,101.52c-8.88,0-16.1,7.22-16.1,16.1 c0,8.88,7.22,16.1,16.1,16.1s16.1-7.22,16.1-16.1C159.15,108.74,151.93,101.52,143.05,101.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.63,84.1c-1.08,0-1.96,0.88-1.96,1.96c0,1.08,0.88,1.96,1.96,1.96c4.02,0,7.29-3.26,7.29-7.28 c0-4.01-3.27-7.28-7.29-7.28h-14.74c-1.08,0-1.96,0.87-1.96,1.95c0,1.08,0.88,1.96,1.96,1.96h6.61c-1.69,3.61-2.62,7.24-2.97,10.77 H92.16l-5.35-9.49c-0.53-0.94-1.72-1.28-2.66-0.74c-0.94,0.53-1.27,1.72-0.74,2.66l5.3,9.4l-18.72,26.53 c-0.42,0.6-0.47,1.38-0.14,2.03c0.34,0.65,1.01,1.06,1.74,1.06h34.95c0.28,0,0.55-0.07,0.8-0.19c0.03-0.02,0.07-0.02,0.1-0.04 c0.24-0.13,0.45-0.31,0.62-0.52c0.02-0.02,0.04-0.03,0.06-0.05l19.43-26.73h4.84c0.18,14.29,8.6,26.06,9.1,26.74 c0.38,0.52,0.98,0.8,1.58,0.8c0.4,0,0.8-0.12,1.15-0.37c0.87-0.64,1.06-1.86,0.43-2.73c-0.15-0.21-14.81-20.68-4.74-39.11h3.74 c1.86,0,3.37,1.51,3.37,3.37C147.01,82.58,145.49,84.1,143.63,84.1z M75.35,115.66l15.47-21.93l12.35,21.93H75.35z M106.73,114 L94.36,92.04h28.34L106.73,114z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.65,81.75c-8.09,0-12.96-2.59-13.19-2.72c-0.95-0.52-1.3-1.71-0.78-2.66c0.51-0.95,1.7-1.3,2.65-0.79 c0.08,0.04,5.86,3.06,15.18,2.04c1.05-0.11,2.04,0.66,2.16,1.73c0.12,1.07-0.66,2.04-1.73,2.16C92.42,81.68,90.99,81.75,89.65,81.75 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.52,91.49c0-0.04,0-0.08-0.01-0.11C117.52,91.41,117.52,91.45,117.52,91.49L117.52,91.49z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.34,89.91L117.34,89.91c0.01,0.08,0.02,0.17,0.04,0.25C117.36,90.08,117.35,90,117.34,89.91z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.83,87.87c-0.02-0.07-0.05-0.13-0.07-0.2C116.78,87.74,116.81,87.81,116.83,87.87L116.83,87.87z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.55,99.97 115.55,99.97 115.54,99.97 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.41,94.56c0,0.02-0.01,0.04-0.01,0.07C117.4,94.6,117.4,94.58,117.41,94.56z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.09,102.05L114.09,102.05c-0.27,0.32-0.55,0.65-0.86,0.95C113.54,102.69,113.82,102.37,114.09,102.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 101.1,
    className: "st3",
    width: 0,
    height: 0
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.11,96.09c-0.01,0.02-0.01,0.04-0.02,0.07C117.1,96.13,117.11,96.11,117.11,96.09z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.54,93.03c0,0.01,0,0.02,0,0.03C117.54,93.05,117.54,93.04,117.54,93.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycling);
export default __webpack_public_path__ + "static/media/Cycling.8af1837e22a7b3fa37c37058904343b4.svg";
export { ForwardRef as ReactComponent };